var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTableGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 712 336.1",
    style: {
      enableBackground: "new 0 0 712 336.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#303030;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#303030;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:9.9996;}\n\t.st2{fill:#FFFFFF;stroke:#303030;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#808285;stroke:#303030;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#767676;stroke:#303030;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#303030;stroke:#303030;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:#010101;stroke:#303030;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000084527800921842547510000002535065515701150639_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000062884759605632970060000010483077771766818957_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60.1,
    y: 115.2,
    className: "st0",
    width: 11.6,
    height: 76.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "71.7,191.8 73.9,183.7 74.3,115.1 71.7,115.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.6,
    y: 103.1,
    className: "st0",
    width: 11.6,
    height: 76.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "67.7,122 62.1,123.8 34.9,43.2 40.3,38.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "37.4,37.3 45.5,36.1 26.1,58.2 15.3,62.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.9,
    y: 64.1,
    transform: "matrix(0.9505 -0.3106 0.3106 0.9505 -28.6709 24.5784)",
    className: "st1",
    width: 5.8,
    height: 76.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.2,
    y: 69.7,
    transform: "matrix(0.9505 -0.3106 0.3106 0.9505 -31.2448 19.6562)",
    className: "st1",
    width: 5.8,
    height: 76.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "65.3,102.3 142,102.3 130.9,137.8 48.4,137.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "40.3,99.4 26.3,58.2 45.5,36.1 58.3,79.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "54.2,214.5 57.7,206.4 58.3,137.8 54.2,137.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "130.9,138.7 130.9,137.8 142,102.9 142,113.4 141.7,114.1 141.4,172.2 139.2,179.8 139.1,122.8  133.4,141.3 133.1,209.3 130.8,217.7 130.8,138.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15.6,62 26.7,58.4 52.6,137.8 54.2,137.8 130.9,137.8 130.9,141.3 130.9,149.4 130.9,218 119.3,218  119.3,149.4 54.2,149.4 54.2,214.5 42.6,214.5 42.6,149.4 42.6,144.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.8,
    y: 196.8,
    className: "st0",
    width: 11.6,
    height: 76.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "57.4,273.5 59.7,265.4 60,196.8 57.4,196.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.4,
    y: 184.8,
    className: "st0",
    width: 11.6,
    height: 76.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.4,203.7 47.8,205.5 21.7,123.4 27.3,121.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "23.1,118.9 31.3,117.8 11.9,139.9 1.1,143.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.7,
    y: 145.7,
    transform: "matrix(0.9505 -0.3106 0.3106 0.9505 -54.7474 24.1963)",
    className: "st1",
    width: 5.8,
    height: 76.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 151.4,
    transform: "matrix(0.9505 -0.3106 0.3106 0.9505 -57.3213 19.2741)",
    className: "st1",
    width: 5.8,
    height: 76.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "51,184 127.7,184 116.7,219.5 34.2,219.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26.1,181.1 12.1,139.9 31.3,117.8 44.1,160.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "40,296.2 43.5,288 44.1,219.5 40,219.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "116.7,220.3 116.7,219.5 127.7,184.6 127.7,195.1 127.5,195.8 127.2,253.9 124.9,261.5 124.8,204.5  119.2,223 118.8,291 116.6,299.4 116.6,220.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1.4,143.7 12.4,140.1 38.4,219.5 40,219.5 116.7,219.5 116.7,223 116.7,231.1 116.7,299.7  105.1,299.7 105.1,231.1 40,231.1 40,296.2 28.4,296.2 28.4,231.1 28.4,226.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 619.9,
    y: 133.9,
    className: "st0",
    width: 11.6,
    height: 76.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "619.9,210.6 617.6,202.5 617.2,133.9 619.9,133.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.4,
    y: 121.9,
    className: "st0",
    width: 11.6,
    height: 76.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.2,
    y: 96.7,
    transform: "matrix(0.3106 -0.9505 0.9505 0.3106 346.7421 677.3482)",
    className: "st1",
    width: 88.3,
    height: 5.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "654.1,56 646,54.9 665.4,77 676.2,81  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 590.4,
    y: 118.2,
    transform: "matrix(0.3106 -0.9505 0.9505 0.3106 318.2563 681.0787)",
    className: "st1",
    width: 76.5,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.1,
    y: 123.8,
    transform: "matrix(0.3106 -0.9505 0.9505 0.3106 324.4548 700.811)",
    className: "st1",
    width: 76.5,
    height: 5.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "626.2,121.1 549.5,121.1 560.6,156.6 643.1,156.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "651.2,118.2 665.2,77 646,54.9 633.2,97.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "637.3,233.3 633.8,225.1 633.2,156.6 637.3,156.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "560.6,157.4 560.6,156.6 549.5,121.7 549.5,132.2 549.8,132.9 550.1,191 552.4,198.6 552.4,141.6  558.1,160 558.4,228.1 560.7,236.5 560.7,157.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "675.9,80.8 664.8,77.2 638.9,156.6 637.3,156.6 560.6,156.6 560.6,160 560.6,168.2 560.6,236.8  572.2,236.8 572.2,168.2 637.3,168.2 637.3,233.3 648.9,233.3 648.9,168.2 648.9,163.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 651.7,
    y: 191.9,
    className: "st0",
    width: 11.6,
    height: 76.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "651.7,268.6 649.5,260.4 649.1,191.9 651.7,191.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 584.2,
    y: 179.8,
    className: "st0",
    width: 11.6,
    height: 76.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628.1,
    y: 154.7,
    transform: "matrix(0.3106 -0.9505 0.9505 0.3106 313.5919 747.6413)",
    className: "st1",
    width: 88.3,
    height: 5.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "686,114 677.9,112.8 697.2,134.9 708.1,139  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622.3,
    y: 176.1,
    transform: "matrix(0.3106 -0.9505 0.9505 0.3106 285.2179 751.336)",
    className: "st1",
    width: 76.5,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639,
    y: 181.7,
    transform: "matrix(0.3106 -0.9505 0.9505 0.3106 291.4164 771.0681)",
    className: "st1",
    width: 76.5,
    height: 5.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "658.1,179.1 581.4,179.1 592.5,214.5 675,214.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "683.1,176.2 697.1,134.9 677.9,112.8 665.1,155.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "669.2,291.2 665.7,283.1 665.1,214.5 669.2,214.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "592.5,215.4 592.5,214.5 581.4,179.7 581.4,190.1 581.7,190.9 582,248.9 584.2,256.6 584.3,199.6  590,218 590.3,286 592.6,294.4 592.6,215.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "707.8,138.7 696.7,135.1 670.8,214.5 669.2,214.5 592.5,214.5 592.5,218 592.5,226.1 592.5,294.7  604.1,294.7 604.1,226.1 669.2,226.1 669.2,291.2 680.8,291.2 680.8,226.1 680.8,221.3  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 199.3,
    y: 34.9,
    className: "st0",
    width: 75.6,
    height: 47.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 31.4,
    className: "st0",
    width: 75.6,
    height: 47.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.9,
    y: 31.4,
    className: "st0",
    width: 75.6,
    height: 47.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.3,
    y: 170.9,
    className: "st3",
    width: 14.2,
    height: 142.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.6,
    y: 170.9,
    className: "st3",
    width: 14.2,
    height: 142.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.1,
    y: 94.8,
    className: "st3",
    width: 14.2,
    height: 123.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.7,
    y: 85.7,
    className: "st3",
    width: 14.2,
    height: 132.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "78.6,302.3 71.5,313.5 71.5,170.9 78.6,163.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "172.4,208.8 165.3,218.5 165.3,95.1 172.4,88.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "591.5,302.2 598.9,313.5 598.6,170.8 591.5,163.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "529.6,207.9 536.6,218.5 536.6,86.2 529.6,78.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "545.4,68.4 158.7,68.4 57.3,170.9 612.8,170.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.3,
    y: 170.9,
    className: "st3",
    width: 555.6,
    height: 9.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "90.3,157.9 151.9,86.6 254.2,86.1 231.5,157.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M254,86.2l-22.7,71.5H90.5l61.5-71L254,86.2 M254.7,85.7l-102.5,0.5l-61.9,71.6h141.6L254.7,85.7L254.7,85.7z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "446.7,162.4 436.6,90.6 553.2,91.1 600.6,162.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M436.7,90.8l116.4,0.5l47.3,71H446.8L436.7,90.8 M436.4,90.5l10.1,72h154.2L553.2,91L436.4,90.5L436.4,90.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "308.2,92.1 323.2,74.9 348.1,74.7 345.7,92.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M348,74.9L345.5,92h-37l14.7-17L348,74.9 M348.2,74.6l-25.1,0.1L308,92.3h37.8L348.2,74.6L348.2,74.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "311.5,94.5 326.5,77.2 351.4,77.1 348.9,94.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M351.3,77.2l-2.4,17.2h-37l14.7-17L351.3,77.2 M351.5,76.9L326.4,77l-15.2,17.5H349L351.5,76.9L351.5,76.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "122.5,144.2 184.2,72.9 286.5,72.4 263.7,144.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M286.3,72.5L263.6,144l-141.3,0.2l62-71.2L286.3,72.5 M286.6,72.2l-102.5,0.5l-61.9,71.5h141.6L286.6,72.2 L286.6,72.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "430.3,151.3 420.2,79.5 536.8,80 584.2,151.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M420.4,79.6l116.4,0.5l47.3,71H430.4L420.4,79.6 M420.1,79.3l10.1,72h154.2l-47.6-71.5L420.1,79.3L420.1,79.3 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M348.5,87.8c-6.7,0-11.4-0.2-12.6-0.4c1.2-0.2,5.9-0.4,12.6-0.4s11.4,0.2,12.6,0.4 C359.9,87.7,355.2,87.8,348.5,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M348.5,87.2c5.2,0,9.2,0.1,11.3,0.3c-2.1,0.1-6.1,0.3-11.3,0.3s-9.2-0.1-11.3-0.3 C339.3,87.3,343.3,87.2,348.5,87.2 M348.5,86.9c-7.1,0-12.9,0.2-12.9,0.5s5.8,0.5,12.9,0.5s12.9-0.2,12.9-0.5 C361.4,87.2,355.6,86.9,348.5,86.9L348.5,86.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M195.8,134.5c-6.7,0-11.4-0.2-12.6-0.4c1.2-0.2,5.9-0.4,12.6-0.4s11.4,0.2,12.6,0.4 C207.1,134.3,202.4,134.5,195.8,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M195.8,133.9c5.2,0,9.2,0.1,11.3,0.3c-2.1,0.1-6.1,0.3-11.3,0.3s-9.2-0.1-11.3-0.3 C186.6,134,190.6,133.9,195.8,133.9 M195.8,133.6c-7.1,0-12.9,0.2-12.9,0.5s5.8,0.5,12.9,0.5s12.9-0.2,12.9-0.5 S202.9,133.6,195.8,133.6L195.8,133.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 264.8,
    y: 235.9,
    className: "st0",
    width: 10.1,
    height: 68.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.9,
    y: 217.6,
    className: "st0",
    width: 10.1,
    height: 68.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.7,
    y: 217.1,
    className: "st0",
    width: 10.1,
    height: 68.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "212,299.1 209.5,304.2 209.5,236.2 212.5,234.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "251.6,280.4 249,286 249,218 252.1,215.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "264.8,236.4 209.5,236.1 199.3,236.1 199.3,248 199.3,304.4 209.5,304.4 209.5,248 264.8,248  264.8,304.4 274.9,304.4 274.9,248 274.9,236.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "304.9,214.6 245.5,214.6 199.3,235.9 274.9,235.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.8,
    y: 195.8,
    className: "st0",
    width: 10.1,
    height: 40.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.3,
    y: 195.8,
    className: "st0",
    width: 10.1,
    height: 40.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "278,234.3 274.9,235.9 274.9,148.6 278,148.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "274.9,235.9 274.9,236.4 274.9,248 274.9,304.4 277.5,299.3 277.9,245.8 301.8,228.2 301.8,285.6  304.9,279.8 305.3,225.3 305.4,225.2 305.4,214.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "212,234.5 209,235.9 209,155.4 212,155.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.3,
    y: 148.6,
    className: "st0",
    width: 75.6,
    height: 47.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 234.8,
    className: "st0",
    width: 10.1,
    height: 68.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.8,
    y: 216.5,
    className: "st0",
    width: 10.1,
    height: 68.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.1,
    y: 215.9,
    className: "st0",
    width: 10.1,
    height: 68.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "477.8,298 480.4,303 480.4,235.1 477.3,233  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "438.3,279.3 440.8,284.9 440.8,216.4 437.7,214.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "425.1,234.8 480.4,234.8 490.5,235.3 490.5,246.9 490.5,303.2 480.4,303.2 480.4,246.9 425.1,246.9  425.1,303.2 414.9,303.2 414.9,246.9 414.9,234.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "384.6,213.4 444.3,213.4 490.5,234.7 414.9,234.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 194.6,
    className: "st0",
    width: 10.1,
    height: 40.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.4,
    y: 194.6,
    className: "st0",
    width: 10.1,
    height: 40.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "411.9,233.2 414.9,234.7 414.9,147.5 411.9,147.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "414.9,234.7 414.9,235.3 414.9,246.9 414.9,303.2 412.4,298.2 412,244.7 388.1,227 388.1,284.4  385,278.7 384.6,224.2 384.6,224.1 384.6,213.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "477.8,233.3 480.9,234.7 480.9,154.3 477.8,154.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.9,
    y: 147.4,
    className: "st0",
    width: 75.6,
    height: 47.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M136.7,129.3c1.9,0,1.9-3,0-3C134.7,126.3,134.7,129.3,136.7,129.3L136.7,129.3z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableGraphic);
export default __webpack_public_path__ + "static/media/table_graphic.df732de69121d5df927594e88921232b.svg";
export { ForwardRef as ReactComponent };